var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCaroleCooper = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 242,
    viewBox: "0 0 173 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.713 151.176C114.782 151.42 114.306 159.042 113.655 168.627C113.003 178.225 105.34 279.398 105.34 279.398L126.763 282.826L142.466 132.196L118.741 127.376L102.968 126.058",
    fill: "#B7C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.713 151.176C114.782 151.42 114.306 159.042 113.655 168.627C113.003 178.225 105.34 279.398 105.34 279.398L126.763 282.826L142.466 132.196L118.741 127.376L102.968 126.058",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.544 151.091C113.589 150.99 113.86 155.604 114.096 159.386C114.33 163.181 113.161 175.571 113.161 175.571C113.161 175.571 83.1458 230.136 83.0397 232.026C82.9336 233.915 92.1892 241.706 97.7464 246.409C103.301 251.126 116.96 258.79 117.769 259.691C118.579 260.591 117.001 269.313 115.146 276.083C113.292 282.853 111.551 281.817 111.551 281.817C111.551 281.817 95.2237 272.955 75.7369 258.564C56.2637 244.174 55.8564 240.674 54.5942 236.644C53.3321 232.614 58.9232 223.96 62.2848 217.235C65.6463 210.51 93.4489 153.824 97.3421 146.231C101.235 138.637 102.963 126.084 102.963 126.084L119.58 127.565",
    fill: "#B7C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.544 151.091C113.589 150.99 113.86 155.604 114.096 159.386C114.33 163.181 113.161 175.571 113.161 175.571C113.161 175.571 83.1458 230.136 83.0397 232.026C82.9336 233.915 92.1892 241.706 97.7464 246.409C103.301 251.126 116.96 258.79 117.769 259.691C118.579 260.591 117.001 269.313 115.146 276.083C113.292 282.853 111.551 281.817 111.551 281.817C111.551 281.817 95.2237 272.955 75.7369 258.564C56.2637 244.174 55.8564 240.674 54.5942 236.644C53.3321 232.614 58.9232 223.96 62.2848 217.235C65.6463 210.51 93.4489 153.824 97.3421 146.231C101.235 138.637 102.963 126.084 102.963 126.084L119.58 127.565",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.468 144.181C139.468 144.181 138.087 144.577 136.05 144.251C134.013 143.925 132.181 138.459 132.979 135.403",
    fill: "#B7C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.468 144.181C139.468 144.181 138.087 144.577 136.05 144.251C134.013 143.925 132.181 138.459 132.979 135.403",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.383 129.433C115.383 129.433 115.012 137.099 114.865 138.015L115.383 129.433Z",
    fill: "#B7C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.383 129.433C115.383 129.433 115.012 137.099 114.865 138.015",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.95 131.531C111.253 131.42 111.223 130.56 111.264 130.301C111.306 130.041 111.831 129.299 112.295 129.373C112.759 129.448 112.98 130.169 112.886 130.756C112.792 131.344 112.305 131.588 111.95 131.531Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6832 44.4301C67.6832 44.4301 75.4792 45.4812 77.5579 46.599C79.6365 47.7168 80.5711 48.273 81.1814 48.3145C81.7917 48.3561 81.8923 47.7272 81.2224 46.5684C80.5525 45.4096 78.4405 44.4127 78.5542 43.7018C78.668 42.9908 79.2657 42.147 79.922 42.252C80.5782 42.357 82.2592 44.2946 83.3305 45.9242C84.4018 47.5539 84.7961 50.0847 83.4087 51.6575C82.0213 53.2303 80.0909 52.8513 79.4987 52.434C78.9064 52.0168 78.038 51.1347 77.7525 51.6919C77.4671 52.2492 76.8709 67.0166 76.8709 67.0166L69.6825 67.6892L64.5425 64.1466L64.6667 54.5197C64.6667 54.5197 60.6002 52.9436 59.3528 51.5382C58.1169 50.1486 57.2141 47.4663 57.1348 45.0699C57.0577 42.6599 58.3275 38.4043 60.4521 38.8844C62.5766 39.3646 64.9784 40.478 67.1714 41.3196C69.3621 42.1749 70.7402 42.6758 70.5127 43.7471C70.2852 44.8184 65.4881 43.9527 64.2795 43.6191C64.2795 43.6191 68.4521 45.4085 69.0044 45.6371C69.5726 45.8542 70.2578 46.5667 70.1988 47.2864C70.1534 48.0083 68.6741 47.7015 68.2776 47.638C67.8948 47.5768 64.7291 46.9441 64.7291 46.9441C64.7291 46.9441 68.9054 48.2713 69.4714 48.5021C70.0396 48.7192 70.5657 49.1118 70.4115 49.9004C70.2573 50.689 69.3489 50.6698 68.8245 50.5298C68.3022 50.3762 64.9587 49.715 64.9587 49.715C64.9587 49.715 68.9705 51.2823 69.6021 51.4535C70.2337 51.6247 70.2261 52.5488 70.1162 52.7977C70.0062 53.0465 69.6524 53.5928 68.609 53.4539C67.5656 53.315 63.7223 52.7982 63.7223 52.7982",
    fill: "#FAE900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6832 44.4301C67.6832 44.4301 75.4792 45.4812 77.5579 46.599C79.6365 47.7168 80.5711 48.273 81.1814 48.3145C81.7917 48.3561 81.8923 47.7272 81.2224 46.5684C80.5525 45.4096 78.4405 44.4127 78.5542 43.7018C78.668 42.9908 79.2657 42.147 79.922 42.252C80.5782 42.357 82.2592 44.2946 83.3305 45.9242C84.4018 47.5539 84.7961 50.0847 83.4087 51.6575C82.0213 53.2303 80.0909 52.8513 79.4987 52.434C78.9064 52.0168 78.038 51.1347 77.7525 51.6919C77.4671 52.2492 76.8709 67.0166 76.8709 67.0166L69.6825 67.6892L64.5425 64.1466L64.6667 54.5197C64.6667 54.5197 60.6002 52.9436 59.3528 51.5382C58.1169 50.1486 57.2141 47.4663 57.1348 45.0699C57.0577 42.6599 58.3275 38.4043 60.4521 38.8844C62.5766 39.3646 64.9784 40.478 67.1714 41.3196C69.3621 42.1749 70.7402 42.6758 70.5127 43.7471C70.2852 44.8184 65.4881 43.9527 64.2795 43.6191C64.2795 43.6191 68.4521 45.4085 69.0044 45.6371C69.5726 45.8542 70.2578 46.5667 70.1988 47.2864C70.1534 48.0083 68.6741 47.7015 68.2776 47.638C67.8948 47.5768 64.7291 46.9441 64.7291 46.9441C64.7291 46.9441 68.9054 48.2713 69.4714 48.5021C70.0396 48.7192 70.5657 49.1118 70.4115 49.9004C70.2573 50.689 69.3489 50.6698 68.8245 50.5298C68.3022 50.3762 64.9587 49.715 64.9587 49.715C64.9587 49.715 68.9705 51.2823 69.6021 51.4535C70.2337 51.6247 70.2261 52.5488 70.1162 52.7977C70.0062 53.0465 69.6524 53.5928 68.609 53.4539C67.5656 53.315 63.7223 52.7982 63.7223 52.7982",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9203 18.4548C59.9203 18.4548 61.7802 18.486 64.6348 18.8726C67.5031 19.2614 74.1185 21.1192 74.1185 21.1192L73.2226 54.5854L59.2804 50.672L59.9203 18.4548Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0056 21.4207L74.119 21.1188L73.2231 54.585C73.2231 54.585 74.9091 54.8268 75.2301 54.4855C75.5511 54.1443 76.3622 32.1621 76.2244 28.1159C76.0866 24.0697 76.0056 21.4207 76.0056 21.4207Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4736 27.1022C66.2775 27.0708 66.1577 26.8008 66.206 26.4991C66.2542 26.1974 66.4523 25.9782 66.6485 26.0096C66.8446 26.041 66.9644 26.311 66.9161 26.6127C66.8679 26.9144 66.6698 27.1335 66.4736 27.1022Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0956 5.39544C80.4891 4.89178 79.0449 5.41786 78.16 6.9168C77.2752 8.41574 77.3611 10.07 77.3698 10.3658C77.3786 10.6617 79.5906 9.89392 80.4541 8.26537C81.3132 6.66416 81.7021 5.8991 81.0956 5.39544Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8098 2.27759C69.5514 1.99212 69.2714 4.09261 69.1358 4.94025C69.0002 5.78788 69.3923 7.98189 69.8757 8.11532C70.3728 8.25095 71.4775 5.90382 71.6738 4.58917C71.8701 3.27452 71.676 2.47227 70.8098 2.27759Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2333 8.14894C61.7966 8.30918 62.2472 5.84338 61.8021 4.59435C61.3569 3.34532 60.5169 1.58442 59.7699 1.87152C59.0229 2.15862 58.9338 4.20552 59.2581 5.07066C59.5938 5.95165 60.337 7.87934 61.2333 8.14894Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6535 54.5182C64.6535 54.5182 60.587 52.9422 59.3396 51.5367C58.1037 50.1471 57.2009 47.4648 57.1216 45.0684C57.0445 42.6584 58.3143 38.4028 60.4389 38.8829C62.5634 39.3631 64.9652 40.4765 67.1581 41.3181C69.3488 42.1734 70.7269 42.6743 70.4994 43.7456C70.2719 44.8169 65.4749 43.9512 64.2663 43.6177C64.2663 43.6177 68.4389 45.407 68.9912 45.6356C69.5594 45.8527 70.2446 46.5653 70.1855 47.2849C70.1401 48.0068 68.6609 47.7 68.2644 47.6365C67.8816 47.5753 64.7158 46.9426 64.7158 46.9426C64.7158 46.9426 68.8922 48.2698 69.4582 48.5006C70.0264 48.7177 70.5525 49.1103 70.3982 49.8989C70.244 50.6875 69.3357 50.6683 68.8113 50.5283C68.289 50.3747 64.9455 49.7135 64.9455 49.7135C64.9455 49.7135 68.9573 51.2808 69.5889 51.452C70.2205 51.6232 70.2129 52.5474 70.1029 52.7962C69.993 53.045 69.6392 53.5913 68.5958 53.4524C67.5524 53.3135 63.709 52.7967 63.709 52.7967",
    fill: "#FAE900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6535 54.5182C64.6535 54.5182 60.587 52.9422 59.3396 51.5367C58.1037 50.1471 57.2009 47.4648 57.1216 45.0684C57.0445 42.6584 58.3143 38.4028 60.4389 38.8829C62.5634 39.3631 64.9652 40.4765 67.1581 41.3181C69.3488 42.1734 70.7269 42.6743 70.4994 43.7456C70.2719 44.8169 65.4749 43.9512 64.2663 43.6177C64.2663 43.6177 68.4389 45.407 68.9912 45.6356C69.5594 45.8527 70.2446 46.5653 70.1855 47.2849C70.1401 48.0068 68.6609 47.7 68.2644 47.6365C67.8816 47.5753 64.7158 46.9426 64.7158 46.9426C64.7158 46.9426 68.8922 48.2698 69.4582 48.5006C70.0264 48.7177 70.5525 49.1103 70.3982 49.8989C70.244 50.6875 69.3357 50.6683 68.8113 50.5283C68.289 50.3747 64.9455 49.7135 64.9455 49.7135C64.9455 49.7135 68.9573 51.2808 69.5889 51.452C70.2205 51.6232 70.2129 52.5474 70.1029 52.7962C69.993 53.045 69.6392 53.5913 68.5958 53.4524C67.5524 53.3135 63.709 52.7967 63.709 52.7967",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5738 60.8855C64.5738 60.8855 70.2141 58.0583 70.9108 57.3845C71.6234 56.6993 72.08 55.5105 71.164 55.3639C70.2617 55.2195 66.9953 55.5662 64.6531 54.5184",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5738 60.8855C64.5738 60.8855 70.2141 58.0583 70.9108 57.3845C71.6234 56.6993 72.08 55.5105 71.164 55.3639C70.2617 55.2195 66.9953 55.5662 64.6531 54.5184",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.736 65.1328L140.411 69.3317L140.142 92.0456C140.142 92.0456 140.275 99.8908 140.936 104.259C141.597 108.627 142.465 132.21 142.465 132.21C142.465 132.21 130.805 131.214 121.74 129.764C112.676 128.313 102.951 126.084 102.951 126.084C102.951 126.084 103.307 117.812 103.669 111.869C104.045 105.928 107.16 79.0143 107.16 79.0143L108.736 65.1328Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.356 129.557C142.356 129.557 125.086 125.322 120.484 123.674C115.88 122.04 104.832 116.08 104.832 116.08L141.977 120.887L142.356 129.557Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.24 97.9218C140.24 97.9218 139.463 99.5361 138.529 96.6946C137.596 93.8531 135.598 90.7431 135.742 78.2731C135.886 65.803 139.682 79.5905 139.682 79.5905L140.17 89.3295L140.24 97.9218Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.771 78.3464C136.437 79.6168 144.87 107.621 145.235 108.759C145.597 109.911 146.155 111.683 145.267 111.54C144.378 111.398 137.952 110.987 132.935 110.353C127.919 109.718 120.091 107.989 120.091 107.989L121.114 119.734C121.114 119.734 144.831 124.342 149.958 125.163C155.084 125.983 158.98 126.873 161.379 123.625C163.777 120.377 160.485 111.508 157.476 100.342C154.468 89.176 145.017 60.1677 138.169 53.5474C134.151 49.6516 126.553 48.6743 122.606 47.9306C116.699 46.8171 112.967 45.9536 110.747 48.3467C108.528 50.7397 76.3305 87.919 76.3305 87.919L76.8709 67.0153C76.8709 67.0153 72.2762 66.1119 69.835 65.5951C67.3938 65.0783 64.5446 64.1317 64.5446 64.1317C64.5446 64.1317 61.7113 91.5671 62.2822 96.4117C62.8689 101.245 65.8799 107.84 71.7313 108.776C77.5828 109.713 83.1689 104.507 87.8692 99.9309C92.5558 95.3526 107.175 79.0009 107.175 79.0009",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.771 78.3464C136.437 79.6168 144.87 107.621 145.235 108.759C145.597 109.911 146.155 111.683 145.267 111.54C144.378 111.398 137.952 110.987 132.935 110.353C127.919 109.718 120.091 107.989 120.091 107.989L121.114 119.734C121.114 119.734 144.831 124.342 149.958 125.163C155.084 125.983 158.98 126.873 161.379 123.625C163.777 120.377 160.485 111.508 157.476 100.342C154.468 89.176 145.017 60.1677 138.169 53.5474C134.151 49.6516 126.553 48.6743 122.606 47.9306C116.699 46.8171 112.967 45.9536 110.747 48.3467C108.528 50.7397 76.3305 87.919 76.3305 87.919L76.8709 67.0153C76.8709 67.0153 72.2762 66.1119 69.835 65.5951C67.3938 65.0783 64.5446 64.1317 64.5446 64.1317C64.5446 64.1317 61.7113 91.5671 62.2822 96.4117C62.8689 101.245 65.8799 107.84 71.7313 108.776C77.5828 109.713 83.1689 104.507 87.8692 99.9309C92.5558 95.3526 107.175 79.0009 107.175 79.0009",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.099 52.4314C131.099 52.4314 129.951 61.7964 128.55 62.7501C127.15 63.7038 124.461 60.876 124.461 60.876",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.099 52.4314C131.099 52.4314 129.951 61.7964 128.55 62.7501C127.15 63.7038 124.461 60.876 124.461 60.876",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.123 58.6834C118.123 58.6834 116.188 61.2203 115.316 61.0666C114.443 60.913 112.916 52.8446 112.183 51.5496",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.123 58.6834C118.123 58.6834 116.188 61.2203 115.316 61.0666C114.443 60.913 112.916 52.8446 112.183 51.5496",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.277 81.2224C127.277 81.2224 124.943 77.6661 125.278 75.5744C125.613 73.4827 127.266 72.1768 127.406 71.3018C127.476 70.8643 127.298 70.8359 127.298 70.8359",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.277 81.2224C127.277 81.2224 124.943 77.6661 125.278 75.5744C125.613 73.4827 127.266 72.1768 127.406 71.3018C127.476 70.8643 127.298 70.8359 127.298 70.8359",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.512 77.6052C113.512 77.6052 110.706 74.6325 111.019 72.6775C111.332 70.7224 114.027 69.0365 114.266 68.6821C114.415 68.4535 114.328 68.2993 114.328 68.2993",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.512 77.6052C113.512 77.6052 110.706 74.6325 111.019 72.6775C111.332 70.7224 114.027 69.0365 114.266 68.6821C114.415 68.4535 114.328 68.2993 114.328 68.2993",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.557 109.682C128.557 109.682 129.36 112.727 129.465 115.31C129.568 117.906 128.91 121.236 128.91 121.236",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.557 109.682C128.557 109.682 129.36 112.727 129.465 115.31C129.568 117.906 128.91 121.236 128.91 121.236",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5988 76.957C76.5988 76.957 74.0263 77.2605 70.0616 76.6262C66.0832 75.9896 64.8391 75.44 64.8391 75.44",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5988 76.957C76.5988 76.957 74.0263 77.2605 70.0616 76.6262C66.0832 75.9896 64.8391 75.44 64.8391 75.44",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4632 83.1276C80.4632 83.1276 80.9449 90.3697 79.4515 93.1314C77.958 95.893 76.5121 94.4137 76.1922 93.8718C75.8586 93.3277 76.3174 87.9187 76.3174 87.9187L80.4632 83.1276Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.301 61.4342L121.787 62.3392L122.096 80.3922C122.096 80.3922 122.546 97.1218 122.474 97.3066C122.402 97.4914 118.57 103.567 118.303 103.482C118.036 103.397 116.81 96.7789 116.828 96.4032C116.846 96.0275 120.358 60.9327 120.358 60.9327L121.301 61.4342Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.683 60.2764C121.683 60.2764 122.251 60.7598 121.991 61.7698C121.731 62.7799 121.341 62.9418 121.06 62.8548C120.78 62.7679 120.182 61.859 120.36 60.92C120.537 59.9947 120.847 59.4555 121.35 59.3817",
    fill: "#5D21D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.683 60.2764C121.683 60.2764 122.251 60.7598 121.991 61.7698C121.731 62.7799 121.341 62.9418 121.06 62.8548C120.78 62.7679 120.182 61.859 120.36 60.92C120.537 59.9947 120.847 59.4555 121.35 59.3817",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.112 119.748C121.112 119.748 106.62 117.345 104.392 117.072C102.164 116.8 100.162 116.606 100.161 114.685C100.174 112.766 100.544 112.292 100.544 112.292C100.544 112.292 99.1926 111.361 99.3457 109.352C99.4852 107.341 100.558 107.036 100.558 107.036C100.558 107.036 98.6321 106.013 98.8897 103.965C99.1609 101.919 100.426 102.164 102.466 102.56C104.508 102.943 107.362 103.33 107.362 103.33L102.003 102.472C102.003 102.472 102.787 100.2 107.037 100.978C111.288 101.756 112.433 105.024 112.428 106.285C112.428 106.285 111.334 106.11 110.979 105.703C110.979 105.703 111.366 106.087 112.428 106.285C113.49 106.483 120.085 108.029 120.085 108.029L121.112 119.748Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5501 91.4692C85.6464 90.8677 86.5782 91.3533 87.2394 91.5152C87.9005 91.677 96.7941 93.4926 98.1487 93.8776C99.5033 94.2626 98.9433 98.4636 98.9433 98.4636C98.9433 98.4636 101.083 99.1986 103.231 99.7105C103.947 99.8811 104.48 100.317 104.877 100.815C105.487 101.908 105.08 102.965 105.08 102.965C105.08 102.965 101.26 102.298 100.773 102.276C100.417 101.349 99.8336 100.962 99.0855 100.73C97.8949 100.371 97.4618 100.975 97.3481 102.036C97.2365 103.084 97.5471 108.153 97.3639 110.438C97.1807 112.722 98.7032 113.022 99.2325 113.218C99.577 113.344 99.9768 113.211 100.339 112.961C100.267 113.328 100.193 113.877 100.191 114.676C100.186 116.021 101.186 116.518 102.559 116.793C101.525 117.469 100.093 117.745 98.7146 117.594C96.1679 117.299 95.7742 115.203 95.7742 115.203C95.7742 115.203 94.687 117.791 90.4401 117.168C86.1932 116.544 84.1758 113.291 83.8477 108.331C83.4627 103.376 85.4539 92.0708 85.5501 91.4692Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9189 88.093C92.9189 88.093 90.3553 86.9397 90.7621 83.3451C91.169 79.7506 92.8408 80.2565 92.8271 79.5532C92.8134 78.8499 92.2091 76.9305 92.6335 75.3298C93.0579 73.7291 94.0012 72.4779 95.382 72.6989C96.7629 72.9198 97.937 74.9585 97.692 76.4897C97.447 78.0209 95.4362 80.6858 95.2787 81.6701C95.1212 82.6545 96.7634 82.8191 96.3871 85.1706C96.0131 87.5084 94.3687 88.4091 92.9189 88.093Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.658 44.7271C112.658 44.7271 112.085 47.2574 110.369 46.8566C108.638 46.4535 107.737 44.3744 108.754 40.8214C109.785 37.2707 111.979 29.4331 111.979 29.4331L115.027 28.785L112.658 44.7271Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.647 17.5783C134.295 17.2021 132.175 17.3114 131.58 21.0301C131.58 21.0301 130.92 20.4198 130.291 20.3192C129.676 20.2207 127.49 21.5255 126.965 24.8067C126.44 28.0879 128.136 29.0602 128.436 29.1083C128.751 29.1586 129.454 29.145 129.682 28.8589C129.682 28.8589 131.922 30.283 132.935 26.8416C133.43 25.154 133.25 24.0876 133.25 24.0876C133.25 24.0876 135.028 24.8909 136.395 25.1097C137.763 25.3284 139.726 24.1844 140.113 21.7646C140.501 19.3447 138.288 17.8408 136.647 17.5783Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.01 48.5161C128.01 48.5161 127.857 59.3724 121.295 58.3224C115.894 57.4584 116.009 49.2041 116.009 49.2041C116.009 49.2041 111.183 49.1329 111.452 43.5112C111.72 37.8895 112.511 34.5247 112.369 33.0438C112.228 31.5629 112.135 28.5475 112.135 28.5475L119.744 27.0868L127.059 31.4962L129.476 37.4214L128.01 48.5161Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.067 45.0829C122.067 45.0829 121.464 50.0763 115.996 49.2013",
    stroke: "#040222",
    strokeWidth: 0.972742,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.49 40.8535C116.49 40.8535 115.652 43.6359 114.176 43.3997C113.178 43.24 112.64 40.7283 112.64 40.7283",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.105 33.9371C114.105 33.9371 113.591 35.4815 113.168 36.1989C112.745 36.9164 112.555 37.489 112.686 37.7203C112.817 37.9516 113.354 38.1917 113.88 38.318C114.407 38.4444 114.489 39.1586 114.212 39.6611",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.529 36.4111L120.364 35.0379",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.384 34.0019C115.384 34.0019 115.153 32.9984 113.766 33.4348",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.067 32.6642C116.358 32.3908 115.497 33.3046 115.243 34.8905C114.989 36.4764 116.489 37.1791 117.597 37.3563C118.704 37.5335 119.965 37.5389 120.306 35.4062C120.648 33.2734 118.067 32.6642 118.067 32.6642Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.869 31.4358C110.188 31.1667 109.643 32.8182 109.505 33.6795C109.365 34.5545 110.294 35.937 111.716 36.1645C113.137 36.392 113.644 35.5897 113.821 34.4824C113.999 33.375 113.318 31.6677 111.869 31.4358Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.4 49.5756C131.437 50.3139 134.576 50.0591 135.171 46.3404C135.766 42.6218 131.696 39.1383 131.294 38.8495C130.878 38.5586 129.018 32.302 128.106 30.2911C127.192 28.294 125.904 25.2135 122.049 24.5967C118.193 23.9798 118.418 23.4548 114.842 23.8081C111.266 24.1613 110.983 27.5934 110.856 28.3864C110.729 29.1793 111.155 30.9019 111.756 30.9982C112.358 31.0944 112.341 30.3206 112.341 30.3206C112.341 30.3206 112.848 30.8363 113.602 29.8913C113.602 29.8913 113.912 30.6701 114.719 30.7991C115.525 30.9282 115.831 30.0658 115.831 30.0658C115.831 30.0658 116.039 31.1366 116.886 31.2722C117.734 31.4078 118.091 30.6657 118.091 30.6657C118.091 30.6657 118.327 31.9935 119.079 32.1138C119.831 32.2341 120.217 30.9638 120.261 30.0735C120.261 30.0735 122.76 31.3706 122.859 34.4292C122.859 34.4292 124.939 35.4491 125.391 35.6055C125.843 35.7619 126.022 34.5567 126.938 34.7032C127.854 34.8498 128.304 36.5062 128.1 37.7777C127.897 39.0491 127.393 39.9219 126.433 39.3477C125.475 38.7598 124.936 38.4492 124.968 37.3746C124.988 36.2842 124.92 36.2732 124.692 36.2087C124.464 36.1442 122.553 35.6422 122.553 35.6422C122.553 35.6422 122.885 41.5422 123.101 43.9605C123.317 46.3787 123.588 47.8383 124.467 48.3015C125.351 48.7373 127.009 49.241 128.4 49.5756Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.416 34.332C118.416 34.332 118.352 35.6945 117.601 35.5743C116.85 35.4541 116.656 34.7368 116.656 34.7368",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.838 33.4414C112.838 33.4414 112.621 34.3592 112.13 34.2805C111.638 34.2018 111.52 33.5386 111.52 33.5386",
    stroke: "#040222",
    strokeWidth: 0.486371,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.174 44.8486C122.174 44.8486 122.456 44.6692 122.539 45.2013C122.848 47.2138 121.325 51.8216 119.286 51.9441C117.264 52.0551 115.553 50.1269 115.553 50.1269L116.091 49.2174C121.473 50.0224 122.174 44.8486 122.174 44.8486Z",
    fill: "#040222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164.107,
    height: 374.702,
    fill: "white",
    transform: "matrix(-0.98744 -0.157994 -0.157994 0.98744 221.246 25.9277)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCaroleCooper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carole-cooper.ee75c2742612255ced788a43e231b2dd.svg";